/** The `<script>` element that loaded the web components bundle, if any. */
export function findWcScript(): HTMLScriptElement | undefined {
  return (document.querySelector('script[src*="web-components.js"]') ||
    Array.from(document.getElementsByTagName('script')).find(
      (s) => s.src && s.src.includes('web-components.js'),
    )) as HTMLScriptElement | undefined;
}
